module.exports = __webpack_public_path__ + "img/features_header_penjualan.18c063c6.png";